import { RawDataResultModel } from "./rawDataResultModel";
import { ImportDataResultModel } from "./importDataResultModel";
import { SyncDataResultModel } from "./syncDataResultModel";
import { UpdateDataResultModel } from "./updateDataResultModel";

export class FullSyncResultModel {
  public loadResult: RawDataResultModel;
  public importResult: ImportDataResultModel;
  public syncResult: SyncDataResultModel;
  public updateResult: UpdateDataResultModel;
}